<script lang="ts">
	import type { UserListItemModel } from '../../types'
	import { melt, type TreeView } from '@melt-ui/svelte'
	import { getContext } from 'svelte'
	import Self from './UserTree.svelte'
	import { Avatar, Icon } from '../../index'

	const {
		elements: { item, group },
		helpers: { isExpanded }
	} = getContext<TreeView>('usertree')

	interface Props {
		items: UserListItemModel[]
		depth: number
	}

	const { depth, items }: Props = $props()
</script>

{#each items as x, i}
	{@const itemId = `${depth}-${i}`}
	{@const hasChildren = x.type === 'group'}
	{@const __MELTUI_BUILDER_2__ = $group({ id: itemId })}
	{@const __MELTUI_BUILDER_1__ = $item({
				id: itemId,
				hasChildren
			})}
	{@const __MELTUI_BUILDER_0__ = $item({
					id: itemId,
					hasChildren
				})}

	{#if x.type === 'user'}
		{@const user = x.data}
		{#snippet template()}
			<div
				class="user-list-item"
				style="--depth: {depth};"
				{...__MELTUI_BUILDER_0__} use:__MELTUI_BUILDER_0__.action
			>
				<div class="user-avatar">
					<Avatar size={20} src={user.avatarURL} />
				</div>
				<div class="username">
					{user.displayName}
					{#if user.isAdmin}
						<div class="admin-sign">
							<Icon icon="wrench" alt="admin" size={18} />
						</div>
					{/if}
				</div>
			</div>
		{/snippet}
		{#if x.href}
			<a href={x.href}>{@render template()}</a>
		{:else}
			{@render template()}
		{/if}
	{:else if x.type === 'group'}
		<button
			class="user-collapse"
			style="--depth: {depth};"
			{...__MELTUI_BUILDER_1__} use:__MELTUI_BUILDER_1__.action
		>
			<div class="more-icon" class:open={$isExpanded(itemId)}>
				<Icon size={18} icon="showMore" alt={$isExpanded(itemId) ? 'collapse' : 'expand'} />
			</div>
			<div class="group-name">{x.name}</div>
		</button>
		<div class="group" {...__MELTUI_BUILDER_2__} use:__MELTUI_BUILDER_2__.action>
			<Self items={x.data} depth={depth + 1} />
		</div>
	{/if}
{/each}

<style>.user-list-item {
  display: flex;
  margin-left: calc(var(--depth) * 24px);
  gap: 4px;
}

.username {
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
}

.admin-sign {
  color: #3b84f1;
  display: inline-block;
  transform: translateY(25%);
}

.user-collapse {
  display: flex;
  margin-left: calc(var(--depth) * 24px);
  gap: 4px;
}
.user-collapse:hover .more-icon {
  opacity: 1;
}

.more-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 22px;
  transition: opacity ease 0.2s, transform ease 0.4s;
  opacity: 0.4;
  transform: rotate(0deg);
}
.more-icon.open {
  transform: rotate(180deg);
}

.group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 16px;
  line-height: 140%;
}

.group-name {
  text-align: left;
}

.user-avatar {
  height: 22px;
}</style>
